<template>
    <div>
        <v-overlay :model-value="loading"
                   containted
                   class="align-center justify-center">
            <v-progress-circular color="primary"
                                 indeterminate
                                 size="64"></v-progress-circular>
        </v-overlay>
        <v-text-field v-if="settingDetails && settingDetails.type == 'text'"
                      v-model="value"
                      :label="settingDetails.label"
                      :hint="settingDetails.help"
                      clearable
                      :loading="saving"
                      @change="saveValue"
                      required></v-text-field>
        <v-text-field v-if="settingDetails && settingDetails.type == 'number'"
                      v-model="value"
                      :label="settingDetails.label"
                      :hint="settingDetails.help"
                      persistent-hint
                      type="number"
                      :rules="[v => v !== null && v !== '' || 'Value is required', v => !isNaN(v) || 'Must be a number']"
                      :loading="saving"
                      @change="saveValue"
                      required></v-text-field>
    </div>
</template>
<style scoped>

</style>
<script>
    import { mapActions, mapState, mapGetters } from "vuex";
    function initialState() {
        return {
            loading: false,
            value: null,
            saving: false
        };
    }
    export default {
        name: "SystemSetting",
        data: function () {
            return initialState();
        },
        mounted: function () {
            this.getValue();
        },
        props: {
            code: String
        },
        methods: {
            ...mapActions([
                'showSuccessSnack',
                'showErrorSnack'
            ]),
            saveValue() {
                if (this.settingDetails && this.settingDetails.type === 'number') {
                    if (this.value === null || this.value === '' || isNaN(this.value)) {
                        this.showErrorSnack("A valid number is required.");
                        return;
                    }
                }
                this.saving = true;
                this.$api.post('/system/setvalue?code='+this.code+'&value='+this.value).then(res => {
                    this.saving = false;
                }).catch(error => {
                    this.saving = false;
                    this.showErrorSnack("Whoops. We ran into an error.");
                });
            },
            getValue() {
                this.loading = true;
                this.$api.get('/system/getvalue?code='+this.code)
                    .then(res => {
                        this.loading = false;
                        this.value = res.data;
                    }).catch(error => {
                        this.loading = false;
                        this.showErrorSnack("Whoops. We ran into an error.");
                    });
            }
        },
        computed: {
            settingDetails() {
                return this.$constants.settings.systemSettings.find((setting) => {
                    return setting.code === this.code;
                });
            }            
        }
    };
</script>